// API client pour la gestion des comptes clients avec JWT Cookie (Express/PostgreSQL)
// VERSION UNIFIÉE: Support cookies httpOnly + fonctions non-auth

const API_BASE = process.env.REACT_APP_LOCAL_API || '/api';

// Helper pour les requêtes avec cookies (credentials: 'include')
const fetchWithCredentials = async (url, options = {}) => {
  return fetch(url, {
    ...options,
    credentials: 'include', // Inclut automatiquement les cookies
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  });
};

// Helper pour les requêtes sans authentification
const fetchWithoutAuth = async (url, options = {}) => {
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  });
};

// === FONCTIONS NON-AUTHENTIFIÉES ===

// Créer un compte client (inscription)
export async function registerClient({ email, password, name, contact_id }) {
  const res = await fetchWithoutAuth(`${API_BASE}/clients`, {
    method: 'POST',
    body: JSON.stringify({ email, password, name, contact_id })
  });
  if (!res.ok) throw new Error('Erreur création compte');
  return await res.json();
}

// Vérifier si un email existe déjà
export async function checkEmailExists(email) {
  const res = await fetchWithoutAuth(`${API_BASE}/clients/check-email`, {
    method: 'POST',
    body: JSON.stringify({ email })
  });
  if (!res.ok) throw new Error('Erreur vérification email');
  const data = await res.json();
  return data.exists;
}

// Vérifier l'accès Zoho et l'inscription locale
export async function verifyEmail(email) {
  const res = await fetchWithoutAuth(`${API_BASE}/clients/verify-email`, {
    method: 'POST',
    body: JSON.stringify({ email })
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || 'Erreur de vérification de l\'email');
  }
  return await res.json();
}

// === FONCTIONS AVEC COOKIES HTTPONLY ===

// Connexion client - JWT stocké dans cookie httpOnly
export async function loginClient({ email, password }) {
  const res = await fetchWithCredentials(`${API_BASE}/clients/login`, {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });
  if (!res.ok) throw new Error('Email ou mot de passe incorrect');
  const data = await res.json();
  
  // Plus besoin de gérer le token côté client, il est dans le cookie httpOnly
  return data;
}

// Déconnexion - Supprimer le cookie côté serveur
export async function logoutClient() {
  const res = await fetchWithCredentials(`${API_BASE}/clients/logout`, {
    method: 'POST'
  });
  if (!res.ok) throw new Error('Erreur lors de la déconnexion');
  return await res.json();
}

// Vérifier le statut d'authentification
export async function checkAuthStatus() {
  try {
    const res = await fetchWithCredentials(`${API_BASE}/clients/auth/status`);
    if (!res.ok) return { authenticated: false };
    return await res.json();
  } catch (error) {
    return { authenticated: false };
  }
}

// Supprimer un compte client (PROTÉGÉ JWT via cookie)
export async function deleteClient(email) {
  const res = await fetchWithCredentials(`${API_BASE}/clients/${encodeURIComponent(email)}`, {
    method: 'DELETE'
  });
  if (!res.ok) throw new Error('Erreur suppression compte');
  return await res.json();
}

// Récupérer un client par email (PROTÉGÉ JWT via cookie)
export async function getClientByEmail(email) {
  const res = await fetchWithCredentials(`${API_BASE}/clients/${encodeURIComponent(email)}`);
  if (!res.ok) throw new Error('Client non trouvé');
  return await res.json();
}
